import React, { useEffect, useState } from "react";
import StandAloneInput from "../../../../../../components/stand-alone-input";

const EmployerSettings = (props) => {
  const [editEmail, setEditEmail] = useState(true);
  const [editPhone, setEditPhone] = useState(true);
  const [editSignerName, setEditSignerName] = useState(true);
  const [editTitle, setEditTitle] = useState(true);
  const [editEmployerName, setEditEmployerName] = useState(true);
  const [editAddress, setEditAddress] = useState(true);
  const [editContractor, setEditContractor] = useState(true);
  const [editTaxId, setEditTaxId] = useState(true);

  function changeSignerName(e) {
    return props.onChange(e, "signerName");
  }

  function changeTitle(e) {
    return props.onChange(e, "signerTitle");
  }

  function changeEmail(e) {
    return props.onChange(e, "email");
  }

  function changePhone(e) {
    return props.onChange(e, "phone");
  }

  function changeEmployerName(e) {
    return props.onChange(e, "employerName");
  };

  function changeAddress(e) {
    return props.onChange(e, "employerAddress");
  };

  function changeContractor(e) {
    props.onChange(e, "contractorName");
  };

  function changeTaxId(e) {
    props.onChange(e, "employerTaxId");
  };


  return (

    <div className="ec_setup_contact reg ">
      {editEmail ? (
        <div className="reportId d-flex align-items-center justify-content-between">

          <div className="reportIdField repordIDCS_wd_100">
            <label>Employer email</label>
            <p className="repordIDCS">
              {props.employerEmail || "Enter email"}
            </p>
          </div>

          <div className="reportIdField">
            <button className="btn reportBtn"
              onClick={() => setEditEmail(!editEmail)}
            >
              Edit
            </button>
          </div>


        </div>

      ) : (

        <div className="SavedReports reportId df align-items-center justify-content-between margin-top-10">
          <div className="input_line ssD_fiels">
            <label>Employer email</label>
            <StandAloneInput
              value={props.employerEmail}
              placeholder={"Enter email"}
              change={changeEmail}
              id="rprt_inpt"
            ></StandAloneInput>

          </div>

          <button className="btn reportBtn"
            onClick={() => setEditEmail(!editEmail)}
          >
            Close
          </button>
        </div>
      )}
      {editPhone ? (
        <div className="reportId d-flex align-items-center justify-content-between">

          <div className="reportIdField repordIDCS_wd_100">
            <label>Employer phone</label>
            <p className="repordIDCS">
              {props.employerPhone || "Enter phone"}
            </p>
          </div>

          <div className="reportIdField">
            <button className="btn reportBtn"
              onClick={() => setEditPhone(!editPhone)}
            >
              Edit
            </button>
          </div>


        </div>

      ) : (

        <div className="SavedReports reportId df align-items-center justify-content-between margin-top-10">
          <div className="input_line ssD_fiels">
            <label>Employer phone</label>
            <StandAloneInput
              value={props.employerPhone}
              change={changePhone}
              placeholder="Enter phone"
              id="rprt_inpt"
            ></StandAloneInput>

          </div>

          <button className="btn reportBtn"
            onClick={() => setEditPhone(!editPhone)}
          >
            Close
          </button>
        </div>
      )}
      {editSignerName ? (
        <div className="reportId d-flex align-items-center justify-content-between">

          <div className="reportIdField repordIDCS_wd_100">
            <label>Signer name</label>
            <p className="repordIDCS">
              {props.signerName || "Please enter signers' name"}
            </p>
          </div>

          <div className="reportIdField">
            <button className="btn reportBtn"
              onClick={() => setEditSignerName(!editSignerName)}
            >
              Edit
            </button>
          </div>


        </div>

      ) : (

        <div className="SavedReports reportId df align-items-center justify-content-between margin-top-10">
          <div className="input_line ssD_fiels">
            <label>Signer name</label>
            <StandAloneInput
              value={props.signerName}
              change={changeSignerName}
              placeholder="Signer Name"
              id="rprt_inpt"
            ></StandAloneInput>

          </div>

          <button className="btn reportBtn"
            onClick={() => setEditSignerName(!editSignerName)}
          >
            Close
          </button>
        </div>
      )}
      {editTitle ? (
        <div className="reportId d-flex align-items-center justify-content-between">

          <div className="reportIdField repordIDCS_wd_100">
            <label>Signer title</label>
            <p className="repordIDCS">
              {props.signerTitle || "Please enter Signers' title"}
            </p>
          </div>

          <div className="reportIdField">
            <button className="btn reportBtn"
              onClick={() => setEditTitle(!editTitle)}
            >
              Edit
            </button>
          </div>


        </div>

      ) : (

        <div className="SavedReports reportId df align-items-center justify-content-between margin-top-10">
          <div className="input_line ssD_fiels">
            <label>Signer title</label>
            <StandAloneInput
              value={props.signerTitle}
              change={changeTitle}
              placeholder="Signer Title"
              id="rprt_inpt"
            ></StandAloneInput>

          </div>

          <button className="btn reportBtn"
            onClick={() => setEditTitle(!editTitle)}
          >
            Close
          </button>
        </div>
      )}
      {editEmployerName ? (
        <div className="reportId d-flex align-items-center justify-content-between">

          <div className="reportIdField repordIDCS_wd_100">
            <label>Employer Name <small>(EIN Default will be used when left empty)</small></label>
            <p className="repordIDCS">
              {props.employerName || "Enter Name"}
            </p>
          </div>

          <div className="reportIdField">
            <button className="btn reportBtn"
              onClick={() => setEditEmployerName(!editEmployerName)}
            >
              Edit
            </button>
          </div>


        </div>

      ) : (
        <div className="SavedReports reportId df align-items-center justify-content-between margin-top-10">
          <div className="input_line ssD_fiels">
            <label>Employer name <small>(EIN Default will be used when left empty)</small></label>
            <StandAloneInput
              value={props.employerName}
              placeholder={"Enter name"}
              change={changeEmployerName}
              id="rprt_inpt"
            ></StandAloneInput>

          </div>

          <button className="btn reportBtn"
            onClick={() => setEditEmployerName(!editEmployerName)}
          >
            Close
          </button>
        </div>
      )}
      {editAddress ? (
        <div className="reportId d-flex align-items-center justify-content-between">

          <div className="reportIdField repordIDCS_wd_100">
            <label>Employer Address <small>(EIN Default will be used when left empty)</small></label>
            <p className="repordIDCS">
              {props.employerAddress || "Enter Address"}
            </p>
          </div>

          <div className="reportIdField">
            <button className="btn reportBtn"
              onClick={() => setEditAddress(!editAddress)}
            >
              Edit
            </button>
          </div>
        </div>
      ) : (
        <div className="SavedReports reportId df align-items-center justify-content-between margin-top-10">
          <div className="input_line ssD_fiels">
            <label>Employer address <small>(EIN Default will be used when left empty)</small></label>
            <StandAloneInput
              value={props.employerAddress}
              placeholder={"Enter name"}
              change={changeAddress}
              id="rprt_inpt"
            ></StandAloneInput>
          </div>
          <button className="btn reportBtn"
            onClick={() => setEditAddress(!editAddress)}
          >
            Close
          </button>
        </div>
      )}
      {editContractor ? (
        <div className="reportId d-flex align-items-center justify-content-between">

          <div className="reportIdField repordIDCS_wd_100">
            <label>Contractor Name <small>(EIN Default will be used when left empty)</small></label>
            <p className="repordIDCS">
              {props.contractorName || "Enter Contractor"}
            </p>
          </div>

          <div className="reportIdField">
            <button className="btn reportBtn"
              onClick={() => setEditContractor(!editContractor)}
            >
              Edit
            </button>
          </div>
        </div>
      ) : (
        <div className="SavedReports reportId df align-items-center justify-content-between margin-top-10">
          <div className="input_line ssD_fiels">
            <label>Contractor Name <small>(EIN Default will be used when left empty)</small></label>
            <StandAloneInput
              value={props.contractorName}
              placeholder={"Enter Contractor"}
              change={changeContractor}
              id="rprt_inpt"
            ></StandAloneInput>
          </div>
          <button className="btn reportBtn"
            onClick={() => setEditContractor(!editContractor)}
          >
            Close
          </button>
        </div>
      )}
      {editTaxId ? (
        <div className="reportId d-flex align-items-center justify-content-between">

          <div className="reportIdField repordIDCS_wd_100">
            <label>Tax Id <small>(EIN Default will be used when left empty)</small></label>
            <p className="repordIDCS">
              {props.employerTaxId || "Enter Tax Id"}
            </p>
          </div>

          <div className="reportIdField">
            <button className="btn reportBtn"
              onClick={() => setEditTaxId(!editTaxId)}
            >
              Edit
            </button>
          </div>
        </div>
      ) : (
        <div className="SavedReports reportId df align-items-center justify-content-between margin-top-10">
          <div className="input_line ssD_fiels">
            <label>Tax Id <small>(EIN Default will be used when left empty)</small></label>
            <StandAloneInput
              value={props.employerTaxId}
              placeholder={"Enter Tax Id"}
              change={changeTaxId}
              id="rprt_inpt"
            ></StandAloneInput>
          </div>
          <button className="btn reportBtn"
            onClick={() => setEditTaxId(!editTaxId)}
          >
            Close
          </button>
        </div>
      )}
    </div>
  );
};
export default EmployerSettings;
